module.exports = __webpack_public_path__ + "b300406b647283a26857d0a7e9f1fa94.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2024-10-31/whats-new.html
// module id = 2343
// module chunks = 0